export enum AiToolkitTypeSlugs {
  updateAi = 'updateai',
  agendaAi = 'agendaai',
  feedbackAi = 'feedbackAi',
  threeSixtyReviews = 'threeSixtyReviews',
  performanceImprovementPlan = 'performanceImprovementPlan',
  careerDevelopmentPlan = 'careerDevelopmentplan',
  performaceReviews = 'performaceReviews',
  meetingNotes = 'meetingNotes',
}
export type AiToolkitType = {
  slug: AiToolkitTypeSlugs;
  title: string;
  description: string;
  buttonText: string;
  image: string;
  to?: string;
  beta?: boolean;
  waitList?: boolean;
  badge?: React.ReactNode;
  managerOnly?: boolean;
};
